import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import DialogLoader from '../../../../components/Loader/DialogLoader';

import { InputBaseField, SelectField, TextareaField } from '../../../../components/InputField/InputField';
import { Label } from '../../../../components/UiElements/UiElements'
import { withSnackbar } from "./../../../../components/Message/Alert";
import useStyles from "./styles";
import { PostDataAPI } from '../../../../Services/APIService';
import { formateMdnNumber, validatePhoneNumber, handleNumberKeyPress, maskCreditCardNumber } from '../../../../../src/components/Common/Extensions';
import { GetUserInfo } from "../../../../Services/GetUserInfo";
import { lstStates, lstCountry, lstMonths, lstCCType } from '../../../../../src/components/Common/Lookup';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import {Input } from 'antd';
function ChangeShippingAddress({ addressType, dialogOpenClose, handleClose, handleSuccessClose, accountNumber, objAddress, ...props }) {
    const classes = useStyles();
    let user_info = JSON.parse(GetUserInfo());
    const [userRole, setUserRole] = useState(user_info.user.roleId);
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({});
    const [errorMessages, setErrorMessages] = useState({});
    const { showMessage } = props;

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isNumber = /\d/.test(keyValue);
        const isSpecialChar = /[^a-zA-Z0-9]/.test(keyValue);
        if (!isNumber || isSpecialChar) {
            event.preventDefault();
        }
    }

    const handleCardChange = (event) => {
        let value = event.target.value.replace(/\D/g, ''); // remove non-numeric characters
        const { name } = event.target;

        if (value.length <= 16) {
            value = value.match(/.{1,4}/g)?.join('-') || ''; // add - space after every 4 digits
        } else {
            value = state.creditCardNumber; // ignore input if it exceeds 16 digits
        }

        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }
    const Validate = (errorList, includeShipment) => {
        if (!state.address1) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: false
            }));
        }

        if (!state.city) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: false
            }));
        }

        if (!state.zip) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: false
            }));
        }

        if (!state.state) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: false
            }));
        }

        if (addressType == "updateBillingAddress") {
            if (!state.billingName) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorNameOnCard: true
                }));
                errorList.push(true);
            } else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorNameOnCard: false
                }));
            }
            if (!validateCreditCardExpiry()) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCardExpiration: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCardExpiration: false
                }));
            }

            if (!state.creditCardNumber) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCardNumber: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCardNumber: false
                }));
            }

            if (!state.creditCardExpirationCvv) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCreditCardCVV: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCreditCardCVV: false
                }));
            }

            const newCreditCardNumber = state.creditCardNumber.replace(/\*/g, '');
            if (newCreditCardNumber && newCreditCardNumber.length != 19) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorInvalidCardNumber: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorInvalidCardNumber: false
                }));
            }

            if (!state.creditCardType) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCardType: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorCardType: false
                }));
            }
        }
        else {
            if (state.phone && !validatePhoneNumber(state.phone)) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorPhone: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorPhone: false
                }));
            }
        }
    }
    const validateCreditCardExpiry = () => {
        if (!state.ccExpMonth || !state.ccExpYear || isNaN(state.ccExpMonth) || isNaN(state.ccExpYear))
            return false;
        if (state.ccExpMonth < 1 || state.ccExpMonth > 12)
            return false;
        if (state.ccExpYear < new Date().getFullYear().toString())
            return false;

        return true;

    }
    const UpdateAddress = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            setIsLoading(true);
            state.accountNumber = accountNumber;
            var obj = { accountNumber: accountNumber };
            if (addressType == "updateBillingAddress") {
                obj.billingAddress1 = state.address1;
                obj.billingAddress2 = state.address2;
                obj.billingCity = state.city;
                obj.billingState = state.state;
                obj.billingName = state.billingName;
                obj.billingZip = state.zip;
                obj.creditCardExpiration = state.ccExpMonth + '/' + state.ccExpYear;
                obj.creditCardNumber = state.creditCardNumber;
                obj.creditCardType = state.creditCardType;
                obj.creditCardExpirationCvv = state.creditCardExpirationCvv;
            }
            else if (addressType == "updateShipAddress") {
                obj.shipAddress1 = state.address1;
                obj.shipAddress2 = state.address2;
                obj.shipCity = state.city;
                obj.shipState = state.state;
                obj.shipName = state.contactName;
                obj.shipPhone = state.phone ? state.phone.replace(' ', '').replace('(', '').replace(')', '').replace('-', '') : '';
                obj.shipZip = state.zip;
            }
            PostDataAPI("telispire/" + addressType, obj, true).then((result) => {
                if (result.success && result.data != null) {

                    if (result.data) {
                        state.creditCardExpiration = obj.creditCardExpiration 
                        handleSuccessClose(state);
                    }
                    else {
                        if (addressType == "updateBillingAddress") {
                            showMessage("Error", "Failed to update billing information, please try again or contact to administrator", "error", 3000);
                        } else {
                            showMessage("Error", "Failed to update shipping address, please try again or contact to administrator", "error", 3000);
                        }
                       
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);

            })
        }
    }

    useEffect(() => {
        if (objAddress) {
            if (objAddress.creditCardExpiration) {
                objAddress.ccExpMonth = objAddress.creditCardExpiration.split('/')[0]
                objAddress.ccExpYear = objAddress.creditCardExpiration.split('/')[1]
            }
            if (objAddress.creditCardNumber) {
                //objAddress.creditCardNumber = objAddress.creditCardNumber.substring(objAddress.creditCardNumber.length - 4, objAddress.creditCardNumber.length)
            }
            setState(objAddress)
        }

    }, []);

    return (
        <>

            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                {...props} >
                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>{addressType === "updateBillingAddress" ? "Payment Information" : "Change Shipping Address"}</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>


                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        <Scrollbars autoHeight autoHeightMax={570}>
                            <div className={classes.content}>
                                <grid container>

                                    {addressType == "updateBillingAddress" ?

                                        <>
                                            <h3> Payment Information </h3>

                                            <Grid row container>
                                                <Grid item sm={6} md={6} lg={6} xl={6} className='paddingRightEight'>
                                                    <Label title="Name On Card" size={6} mandatory={true} />
                                                    <InputBaseField
                                                        name="billingName"
                                                        value={state?.billingName}
                                                        onChange={handleChange}
                                                        placeholder="Name On Card"
                                                        type="text"
                                                        MaxLength={50}
                                                    />
                                                    {errorMessages.errorNameOnCard && !state.billingName ? (<FormHelperText style={{ color: "red" }} >
                                                        Please enter name on card
                                                    </FormHelperText>) : ('')}
                                                </Grid>

                                                <Grid item sm={6} md={6} lg={6} xl={6}>

                                                    <Label title="Card Type" size={12} mandatory={true} />

                                                    <Select
                                                        size="small"
                                                        native
                                                        name="creditCardType"
                                                        value={state?.creditCardType}
                                                        onChange={handleSelectChange}
                                                        placeholder="Select Credit Card Type"
                                                        label="Select"
                                                        disabled={userRole == 3 ? true : false}
                                                        className={classes.selectBaseInput}
                                                    >
                                                        {lstCCType.map(option =>
                                                            <option value={option.value}>{option.label}</option>
                                                        )
                                                        }
                                                    </Select>
                                                    {errorMessages.errorCardType && !state.creditCardType ? (<FormHelperText style={{ color: "red" }} >
                                                        Please select credit card type
                                                    </FormHelperText>) : ('')}



                                                </Grid>
                                            </Grid>

                                            <Grid row container>

                                                <Grid item sm={6} md={6} lg={6} xl={6} className='paddingRightEight'>
                                                    <Label title="Card Number" size={3} mandatory={true} />

                                                    <InputBaseField
                                                        name="creditCardNumber"
                                                        value={state?.creditCardNumber}
                                                        onChange={handleCardChange}
                                                        placeholder="Credit Card Number"
                                                        type="text"
                                                        IsDisabled={userRole == 3 ? true : false}
                                                        MaxLength={19}
                                                    />
                                                    {errorMessages.errorCardNumber && !state.creditCardNumber ? (<FormHelperText style={{ color: "red" }} >
                                                        Please enter credit card number
                                                    </FormHelperText>) : ('')}
                                                    {errorMessages.errorInvalidCardNumber && state.creditCardNumber && state.creditCardNumber.length != 19 ? (<FormHelperText style={{ color: "red" }} >
                                                        Please enter valid credit card number
                                                    </FormHelperText>) : ('')}
                                                </Grid>

                                                
                                                <Grid item sm={6} md={6} lg={6} xl={6} >
                                                    <Label title="Expiry Date" size={12} mandatory={true} />

                                                    <div className={classes.expireDate}>

                                                        <Select
                                                            size="small"
                                                            native
                                                            name="ccExpMonth"
                                                            value={state?.ccExpMonth}
                                                            onChange={handleSelectChange}
                                                            placeholder="Select Month"
                                                            label="Select"
                                                            disabled={userRole == 3 ? true : false}
                                                            className={classes.selectBaseInput}
                                                        >
                                                            {lstMonths.map(option =>
                                                                <option value={option.value}>{option.label}</option>
                                                            )
                                                            }
                                                        </Select>

                                                        <InputBaseField
                                                            name="ccExpYear"
                                                            value={state?.ccExpYear}
                                                            onChange={handleChange}
                                                            placeholder="Year"
                                                            type="text"
                                                            MaxLength={4}
                                                            IsDisabled={userRole == 3 ? true : false}
                                                            onKeyPress={(e) => handleNumberKeyPress(e)}
                                                        />
                                                    </div>

                                                    {errorMessages.errorCardExpiration && !validateCreditCardExpiry() ? (<FormHelperText style={{ color: "red" }} >
                                                        Please enter valid credit card expiration
                                                    </FormHelperText>) : ('')}
                                                </Grid>


                                            </Grid>

                                            <Grid row container>
                                                <Grid item sm={6} md={6} lg={6} xl={6} className='paddingRightEight'>
                                                    <Grid row>
                                                        <Label title="Card CVV" size={3} mandatory={true} />

                                                        {/*<InputBaseField*/}
                                                        {/*    name="creditCardExpirationCvv"*/}
                                                        {/*    value={state?.creditCardExpirationCvv}*/}
                                                        {/*    onChange={handleChange}*/}
                                                        {/*    placeholder="Card CVV"*/}
                                                        {/*    type="text"*/}
                                                        {/*    onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                                                        {/*    IsDisabled={userRole == 3 ? true : false}*/}
                                                        {/*    MaxLength={3}*/}
                                                        {/*/>*/}

                                                        <Input.Password
                                                            name="creditCardExpirationCvv"
                                                            type="password"
                                                            value={state?.creditCardExpirationCvv}
                                                            onChange={handleChange}
                                                            placeholder="Card CVV"
                                                            autoComplete="off"
                                                            onKeyPress={(e) => handleNumberKeyPress(e)}
                                                            disabled={userRole == 3 ? true:false}
                                                            MaxLength={3}
                                                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                                        />

                                                        {errorMessages.errorCreditCardCVV && !state.creditCardExpirationCvv ? (<FormHelperText style={{ color: "red" }} >
                                                            Please enter card cvv
                                                        </FormHelperText>) : ('')}

                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <h3> Billing Information </h3>
                                            <hr className="greyLine"></hr>
                                        </>
                                        : ''}
                                </grid>
                                <Grid container spacing={2} className={classes.shippinglayout}>

                                    <Grid item sm={6} md={6} lg={6} xl={6} style={{ order: addressType == "updateBillingAddress" ? 1 : 0 }}>
                                        {addressType == "updateBillingAddress" ?
                                            '' : <Grid row >
                                                <Label title="Name" size={2} />
                                                <InputBaseField
                                                    name="contactName"
                                                    value={state?.contactName}
                                                    onChange={handleChange}
                                                    placeholder="Name"
                                                    type="text"
                                                    IsDisabled={userRole == 3 ? true : false}
                                                    MaxLength={80}
                                                />
                                            </Grid>}
                                        <Grid row >
                                            <Label title="Address 2" size={2} />
                                            <InputBaseField
                                                name="address2"
                                                value={state?.address2}
                                                onChange={handleChange}
                                                placeholder="Address 2"
                                                type="text"
                                                IsDisabled={userRole == 3 ? true : false}
                                                MaxLength={80}
                                            />
                                        </Grid>

                                        <Grid row >
                                            <Label title="State" size={2} mandatory={true} />

                                            <Select
                                                size="small"
                                                native
                                                name="state"
                                                value={state?.state}
                                                onChange={handleSelectChange}
                                                placeholder="Select"
                                                label="Select"
                                                disabled={userRole == 3 ? true : false}
                                                className={classes.selectBaseInput}
                                            >
                                                {lstStates.map(option =>
                                                    <option value={option.value}>{option.label}</option>
                                                )
                                                }
                                            </Select>
                                            {errorMessages.errorState && !state.state ? (<FormHelperText style={{ color: "red" }} >
                                                Please select state
                                            </FormHelperText>) : ('')}
                                        </Grid>


                                        {addressType == "updateShipAddress" ?
                                            <>
                                                <Grid row >
                                                    <Label title="Phone" size={2} />
                                                    <InputBaseField
                                                        name="phone"
                                                        value={formateMdnNumber(state?.phone)}
                                                        onChange={handlePhoneChange}
                                                        placeholder="Phone"
                                                        type="text"
                                                        IsDisabled={userRole == 3 ? true : false}
                                                        MaxLength={14}
                                                    />
                                                </Grid>
                                                {errorMessages.errorPhone && state.phone && !validatePhoneNumber(state.phone) ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter valid phone number
                                                </FormHelperText>) : ('')}
                                            </>
                                            : ''}



                                    </Grid>

                                    <Grid item sm={6} md={6} lg={6} xl={6} style={{ order: addressType == "updateBillingAddress" ? 0 : 1 }}>

                                        <Grid row >
                                            <Label title="Address 1" size={12} mandatory={true} />
                                            <InputBaseField
                                                name="address1"
                                                value={state?.address1}
                                                onChange={handleChange}
                                                placeholder="Address 1"
                                                type="text"
                                                IsDisabled={userRole == 3 ? true : false}
                                                MaxLength={80}
                                            />
                                            {errorMessages.errorAddress1 && !state.address1 ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter address 1
                                            </FormHelperText>) : ('')}
                                        </Grid>

                                        <Grid row >
                                            <Label title="City" size={12} mandatory={true} />
                                            <InputBaseField
                                                name="city"
                                                value={state?.city}
                                                onChange={handleChange}
                                                placeholder="City"
                                                type="text"
                                                IsDisabled={userRole == 3 ? true : false}
                                                MaxLength={80}
                                            />
                                            {errorMessages.errorCity && !state.city ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter city
                                            </FormHelperText>) : ('')}
                                        </Grid>

                                        <Grid row >
                                            <Label title="Zip Code" size={12} mandatory={true} />
                                            <InputBaseField
                                                name="zip"
                                                value={state?.zip}
                                                onChange={handleChange}
                                                placeholder="Zip Code"
                                                type="text"
                                                MaxLength={10}
                                                IsDisabled={userRole == 3 ? true : false}
                                                onKeyPress={(e) => handleKeyPress(e)}
                                            />
                                            {errorMessages.errorZip && !state.zip ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter zip code
                                            </FormHelperText>) : ('')}
                                        </Grid>



                                    </Grid>
                                </Grid>
                            </div>
                        </Scrollbars>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                                {userRole != 3 ? <Button className={classes.changeBtn} onClick={UpdateAddress}>Submit</Button> : ''}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >







        </>
    )
}

export default withSnackbar(ChangeShippingAddress);
